export default {"src":"/_next/static/image/public/images/voucher_tag.ebc4d236f9362eaab81eaf4046587b63.svg","height":32,"width":32};